import portfolioImg01 from "../images/portfolio-1.png";
import portfolioImg02 from "../images/portfolio-2.png";
import portfolioImg03 from "../images/portfolio-3.png";
import portfolioImg04 from "../images/portfolio-4.png";
import portfolioImg05 from "../images/portfolio-5.png";
import portfolioImg06 from "../images/portfolio-6.png";
import UX from "../images/UX.png";
import python from '../images/python.png'

const portfolios = [
  {
    id: "01",
    imgUrl: portfolioImg01,
    category: "Web Design",
    title: "E-commerce Website",
    description:
      "E-Commerce Website design for sales and service of AK GROUP products",
    technologies: ["React","SpringBoot" ,"My-Sql"],
    siteUrl: "#",
  },
  {
    id: "02",
    imgUrl: portfolioImg02,
    category: "Web Design",
    title: "Wordpress Site Design For AK GROUP ",
    description:
      "Website design for AK GROUP with the help of Wordpress",
    technologies: ["Wordpress"],
    siteUrl: "#",
  },
  {
    id: "03",
    imgUrl: portfolioImg03,
    category: "Web Design",
    title: "E-pharma Website",
    description:
      "E-pharma website design for online purchase of medicine and medical equipment",
    technologies: ["React","SpringBoot","My-Sql"],
    siteUrl: "#",
  },
  {
    id: "04",
    imgUrl: portfolioImg04,
    category: "Web Design",
    title: "Open Ai",
    description:
      "Open Ai created by usin api key from Chatgpt ",
    technologies: ["React", "Tailwind css", "Node.js"],
    siteUrl: "#",
  },
  {
    id: "05",
    imgUrl: portfolioImg05,
    category: "Web Design",
    title: "Web Form ",
    description:
      "Web Form created for Ak retail for sendind the data from frontend to backend into database (Firebase)",
    technologies: ["React", "Node.js", "Firebase"],
    siteUrl: "#",
  },

  {
    id: "06",
    imgUrl: portfolioImg06,
    category: "Web Design",
    title: "Portfolio",
    description:
      "Portfolio created for Ajai Kulkarni",
    technologies: ["React", "Tailwind css", "Node.js", "MongoDB"],
    siteUrl: "#",
  },
  {
    id: "07",
    imgUrl: UX,
    category: "UX",
    title: "User Experience Design",
    description:
      "UX design in figma tool",
    technologies: ['figma'],
    siteUrl: "#",
  },
  
];

export default portfolios;
